import React from 'react'

import ReactGA from 'react-ga'

import jptiCta from './jpti_CTA-General Version-080725.png'
import { VideoPlayer, VideoThumbnail } from '../../Utils/GumletVideo'

export const NextStepsPage = ({showFeedback=true}) => {
    return (
        <>
            <h1>Putting It All Together.</h1>

            <VideoPlayer videoID="68a7a4b80a8c57042d58fa13" />
            <VideoThumbnail videoID="68a7a4b80a8c57042d58fa13" />

            <p>
                Congratulations! You've successfully reached a life-changing milestone in your career
                planning. Let's recap your progress.
            </p>
            <p>
                First, you pinpointed the personal values that are most important in guiding your thinking,
                decision making, and actions at this time in your life. And based on those values, our
                assessment has narrowed down the hundreds of possible categories of careers that you could
                consider into just a few Job Passion Types.
            </p>
            <p>
                Then you were able to zero in on the one Job Passion Type that resonates best with you
                based on how closely it aligned with the shortlist of Core Values and Supporting Values
                that matter most to you right now.
            </p>
            <p>
                And finally, you've been able to narrow down the comprehensive list of occupation title
                suggestions for that Job Passion Type to a target list of just three to five Job Passion Title
                possibilities that warrant serious consideration.
            </p>

            <p>
                Here's what to do next:
            </p>
            <p className="text-primary">
                Conduct a focused online search for each of the Job Passion Titles on that target list to
                learn more about the job descriptions and qualifications they require.
            </p>
            <p>
                If you search for that job title on Google or any other online search engine, you'll be
                able to find detailed job descriptions, including the skills and education required to do
                those jobs well. You should end up with a target list of job opportunities you'd be
                interested in pursuing based on your personality, current strengths, and skillsets.
            </p>
            <p>
                Make sure that the skills and strengths you want to leverage in pursuing these job titles
                are ones that you enjoy doing. Over the years, your employer may have encouraged or
                required you to develop strengths and skills that are not in alignment with your values.
                These are the ones that you won't currently enjoy doing. You should avoid leveraging
                these as you move forward towards your Job Passion, as they will continue to be sources
                of frustration and unfulfillment.
            </p>

            <p className="text-primary">
                Now that you've fine-tuned your Job Passion Title target list, you have three choices for
                how to proceed:
            </p>
            <ol>
                <li>
                    DO IT YOURSELF &ndash; You can search job listings on your own to identify
                    opportunities that fit your Job Passion Title target list. Then you can research the
                    websites of those companies to identify only those whose values align most closely
                    with your Core and Supporting Values.
                </li>
                <li>
                    DO IT WITH HELP &ndash; You can participate in our next JOB PASSION DISCOVERY
                    WORKSHOP&trade;. In this online workshop, you'll discover the exact steps to convert
                    your list of values and Job Passion Titles into an action plan for finding companies
                    and job listings that are ideal for you.
                    {' '}
                    <ReactGA.OutboundLink
                        eventLabel="workshop"
                        to="https://careerzgroup.com/events"
                        target="_blank"
                    >CLICK TO LEARN MORE</ReactGA.OutboundLink>
                </li>
                <li>
                    DO IT TOGETHER &ndash; You can schedule a complimentary Job Passion Discovery call
                    with us. On that call we can give you more insights about your results and
                    discuss options for private coaching that might make more sense for you in your
                    current situation.
                    {' '}<br />
                    <ReactGA.OutboundLink
                        eventLabel="schedule_call"
                        to="https://lunacal.ai/team/careerzgroup/job-passion-assessment-consumer-consult"
                        target="_blank"
                    >CLICK TO SCHEDULE A CALL</ReactGA.OutboundLink>
                </li>
            </ol>
            {
                showFeedback &&
                <div style={{marginTop: "50px", marginBottom: "50px"}} className="text-center">
                    <ReactGA.OutboundLink
                            eventLabel="survey"
                            to="https://getformly.app/7kdwUf"
                            target="_blank"
                    >
                        <img className="d-block w-100" src={jptiCta} alt="Feedback" />
                    </ReactGA.OutboundLink>
                </div>
            }
        </>
    )
}